import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController, LoadingController, Note } from 'ionic-angular';

import { TaskMarketing as Task, MasterMarketing as Master, NotesMarketing as Notes } from '@providers/index';

@Component({
  selector: 'page-notes',
  templateUrl: 'page.html'
})
export class DetailTaskPage {

  form = {
    id : '',
    task : '',
    date_start : '',
    date_end : '',
    description : '',
    pic_name :'',
    pic_id :'',
    tender_id:'',
    state_id: 1
  };
  now_state_id = 1;
  note = '';
  listState:any = [];
  tender:any = {};
  loading:any;
  notes=[];
  
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public taskApi: Task,
    public notesApi: Notes,
    public masterApi: Master
  ) {

    this.getState();
    this.tender = this.navParams.get('tender');
    if(this.navParams.get('rec')!=undefined){
      this.form = this.navParams.get('rec');
      this.now_state_id = this.form.state_id;
      this.getNotes();
    }
    
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  getNotes(){
    let params = {
      tender_id : this.tender.id,
      related_id : this.form.id,
      related_to : 'Task'
    }
    this.notesApi.get(params).subscribe((resp:any) => {
      this.notes = resp.data;
    });
  }

  getState(){
    this.showLoading();
    let params = {};
    this.masterApi.state(params).subscribe((resp:any) => {
      this.listState = resp.data;
      this.loading.dismiss();
    });
  }

  save(){    
    this.showLoading();
    this.form.tender_id = this.tender.id;
    let params = this.form;
    this.taskApi.post(params).subscribe((resp:any) => {
      this.presentToast(resp.msg);
      this.loading.dismiss();
      this.add_note();
    },(err) => {
      this.presentToast('Error');
      this.loading.dismiss();
    });
  }

  add_note(){    
    this.showLoading();
    let params = {
      tender_id : this.tender.id,
      note : this.note,
      related_to : 'Task',
      related_id : this.form.id,
      related_notes : this.form.task
    };
    this.notesApi.post(params).subscribe((resp:any) => {
      this.presentToast(resp.msg);
      this.loading.dismiss();
      this.navCtrl.pop();
    },(err) => {
      this.presentToast('Error');
      this.loading.dismiss();
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/marketing/detail_task/page.ts